import { useQuery } from '@tanstack/react-query';

import axios, { parseAxiosError } from '@/portainer/services/axios';
import {
  EnvironmentId,
  EnvironmentType,
} from '@/react/portainer/environments/types';

import { EdgeGroup } from '../types';

import { queryKeys } from './query-keys';

export interface EdgeGroupListItemResponse extends EdgeGroup {
  EndpointTypes: Array<EnvironmentType>;
  HasEdgeStack?: boolean;
  HasEdgeJob?: boolean;
  HasEdgeConfig?: boolean;
  TrustedEndpoints: Array<EnvironmentId>;
  EndpointsCount: number;
  TrustedEndpointsCount: number;
}

export function useEdgeGroups<T = EdgeGroupListItemResponse[]>({
  summarize,
  select,
}: {
  summarize?: boolean;
  select?: (groups: EdgeGroupListItemResponse[]) => T;
} = {}) {
  return useQuery({
    queryKey: queryKeys.base(summarize),
    queryFn: () => getEdgeGroups({ summarize }),
    select,
  });
}

async function getEdgeGroups({ summarize }: { summarize?: boolean }) {
  try {
    const { data } = await axios.get<EdgeGroupListItemResponse[]>(
      '/edge_groups',
      {
        params: { summarize },
      }
    );
    return data;
  } catch (err) {
    throw parseAxiosError(err as Error, 'Failed fetching edge groups');
  }
}
